// Modern browsers and React 18+ do not require these polyfills. Remove deprecated imports.
import * as React from "react";
import * as ReactDOM from "react-dom/client";

import { setupInject } from "app/di";
import {
    AppConfigLoaderService,
    IAppConfigProvider
} from "app/services/config/app-config-loader.service";
import { AjaxService } from "app/services/infrastructure/ajax-service";
import { AjaxSparqlExecutor, ISparqlExecutor } from "app/services/infrastructure/sparql-executor";
import { Main } from "app/ui/main";
import { ErrorPage } from "app/ui/pages/error.page";

import "./app.less";

async function runApp() {
    const appHostDomElement = document.getElementById("app-container") || document.body;
    console.log("runApp: started");
    try {
        const ajaxService = new AjaxService();
        const confLoader = new AppConfigLoaderService();
        console.log("runApp: loading config...");
        const appConfig = await confLoader.loadConfig(ajaxService);
        console.log("runApp: config loaded", appConfig);
        const sparqlExecutor = new AjaxSparqlExecutor(appConfig.dataServiceOptions);

        // Setup the global dependency injection container
        setupInject(IAppConfigProvider, confLoader);
        setupInject(ISparqlExecutor, sparqlExecutor);

        // Render the app using React 18+ root API
        console.log("runApp: rendering Main");
        const root = ReactDOM.createRoot(appHostDomElement);
        root.render(<Main />);
    } catch (ex) {
        console.error("runApp: error", ex);
        const root = ReactDOM.createRoot(appHostDomElement);
        root.render(<ErrorPage error={ex as Error} />);
        throw ex;
    }
}

Object.assign(window, {
    app: {
        run: runApp
    }
});
